import React__default from 'react';
import styles from './Toolbar.scss.mjs';
import { Section as Section$1 } from './components/Item/Section.mjs';

function Toolbar({
  children
}) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.Toolbar
  }, children);
}
function Group({
  children
}) {
  return /*#__PURE__*/React__default.createElement("ul", {
    className: styles.Group
  }, children);
}
function Section({
  children
}) {
  return /*#__PURE__*/React__default.createElement(Section$1, null, /*#__PURE__*/React__default.createElement("ul", {
    className: styles.Section
  }, children));
}

export { Group, Section, Toolbar };
